<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.5 3.33331L12.9882 8.82145C13.639 9.47233 13.639 10.5276 12.9882 11.1785L7.5 16.6666"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: number
  }>(),
  {
    size: 16,
  }
)
</script>
